import getList from './getList';
import add from './add';
import edit from './edit';
import del from './del';
import getMethodList from './getMethodList';
export default {
  getList,
  add,
  del,
  edit,
  getMethodList,
};


// WEBPACK FOOTER //
// ./src/api/heatbeatgroups/index.ts